import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { buildBotLink, MAX_CHANNEL_URL } from "@/lib/site";
import { trackClick } from "@/lib/track";

export const CTAButton = ({
  goal = "cta_max_bot",
  channel = false,
  children,
  className = "",
  showArrow = true,
  testId,
  size = "lg",
}) => {
  const isPrimary = !channel;
  const href = channel ? MAX_CHANNEL_URL : buildBotLink();

  const handleClick = (e) => {
    e.preventDefault();
    trackClick(channel ? "channel" : "bot");
    window.open(href, "_blank", "noopener,noreferrer");
  };

  const pad = size === "sm" ? "px-5 py-2.5 text-sm" : "px-8 py-4 text-base";

  return (
    <motion.a
      href={href}
      onClick={handleClick}
      data-goal={goal}
      data-testid={testId}
      whileHover={{ scale: 1.035 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 400, damping: 22 }}
      className={`group inline-flex items-center justify-center gap-2.5 rounded-full font-semibold tracking-wide ${pad} ${
        isPrimary
          ? "gold-gradient text-[#0B0B1F] glow-gold"
          : "border border-[#D4AF6E]/50 text-[#EDE6D3] hover:border-[#D4AF6E] hover:bg-[#D4AF6E]/10"
      } ${className}`}
    >
      {children}
      {showArrow && (
        <ArrowRight className="h-[1.15em] w-[1.15em] transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </motion.a>
  );
};
